export const ERROR_500 = 'Something went wrong! Please contact support if the issue persists.'
